module.exports = __webpack_public_path__ + "media/images/lb/706-ffd279e754dfd00ea0ae7224aa95de4f.svg";